import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import TrainingPlanSelection from './pages/training-plan-selection';
import TrainingPlanBuilder from './pages/training-plan-builder';
import TrainerDashboard from './pages/trainer-dashboard';
import ClientManagement from './pages/client-management';
import ExerciseExecution from './pages/exercise-execution';
import ExerciseDatabase from './pages/exercise-database';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ClientManagement />} />
        <Route path="/training-plan-selection" element={<TrainingPlanSelection />} />
        <Route path="/training-plan-builder" element={<TrainingPlanBuilder />} />
        <Route path="/trainer-dashboard" element={<TrainerDashboard />} />
        <Route path="/client-management" element={<ClientManagement />} />
        <Route path="/exercise-execution" element={<ExerciseExecution />} />
        <Route path="/exercise-database" element={<ExerciseDatabase />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
